export default __webpack_public_path__ + "assets/images/782c073c3df6917fde8a23be5e579703.png";